export const CONTACT_TYPES = {
  EMPLOYEE: 'E',
  CUSTOMER: 'C',
} as const
